<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    <circle
      style="stroke: #231f20; fill: #231f20; opacity: .5;"
      class="cls-1"
      cx="32"
      cy="29.96"
      r="20.25"
    />
    <circle
      style="fill: #116c99; stroke: #fff; stroke-width: 4px;"
      class="cls-2"
      cx="32"
      cy="32.2"
      r="28"
    />
    <path
      style="fill: #fff;"
      class="cls-3"
      d="M39.84,32.24c-.02,4.32-3.52,7.82-7.84,7.84-4.35-.02-7.87-3.57-7.85-7.92.03-4.32,3.53-7.82,7.85-7.84,4.35.02,7.87,3.56,7.84,7.92Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'PortfolioIcon',
};
</script>

<style scoped lang="scss">
.cls-1, .cls-2 {
  stroke-miterlimit: 10;
  stroke-width: 2px;
}
</style>
